import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { addUtils } from './class-name-helpers';

export const Divider = ({ className, ...props }) => {
  const { utilClassNames, restProps } = addUtils(props);

  return (
    <hr className={clsx(className, 'ss_divider', utilClassNames)} {...restProps} />
  );
};

Divider.propTypes = {
  className: PropTypes.string,
};

Divider.defaultProps = {
  className: '',
};
